import { render, staticRenderFns } from "./comparer.vue?vue&type=template&id=147e1c4b&scoped=true&lang=pug&"
import script from "./comparer.vue?vue&type=script&lang=js&"
export * from "./comparer.vue?vue&type=script&lang=js&"
import style0 from "./comparer.vue?vue&type=style&index=0&id=147e1c4b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147e1c4b",
  null
  
)

export default component.exports